export const INSPECTION_STATUS_META = {
    pending: { es: 'Pendiente', en: 'Pending', severity: 'warning' },
    in_progress: { es: 'En proceso', en: 'In progress', severity: 'info' },
    completed: { es: 'Completada', en: 'Completed', severity: 'success' },
    cancelled: { es: 'Cancelada', en: 'Cancelled', severity: 'danger' }
};

export const INSPECTION_RESULT_OPTIONS = [
    { value: 'pending', es: 'Por definir', en: 'Not set' },
    { value: 'suitable', es: 'Apta para instalación', en: 'Suitable for installation' },
    { value: 'suitable_with_adjustments', es: 'Apta con adecuaciones', en: 'Suitable with adjustments' },
    { value: 'not_suitable', es: 'No apta', en: 'Not suitable' }
];

export const INSPECTION_CHECKLIST_OPTIONS = [
    { value: 'pending', es: 'Pendiente', en: 'Pending' },
    { value: 'yes', es: 'Cumple', en: 'Compliant' },
    { value: 'no', es: 'No cumple', en: 'Not compliant' },
    { value: 'not_applicable', es: 'No aplica', en: 'Not applicable' }
];

const items = (values) => values.map(([key, label]) => ({ key, label, value: 'pending', note: '', photos: [] }));

export const buildEmptyInspectionChecklist = () => [
    {
        key: 'physical_site',
        label: 'Espacio físico',
        items: items([
            ['sufficient_space', 'Espacio suficiente para el equipo previsto'],
            ['level_surface', 'Superficie firme y nivelada'],
            ['ventilation', 'Ventilación adecuada'],
            ['weather_protection', 'Área protegida de lluvia, sol y humedad']
        ])
    },
    {
        key: 'access_logistics',
        label: 'Acceso y logística',
        items: items([
            ['transport_access', 'Acceso viable para trasladar el equipo'],
            ['door_elevator_clearance', 'Puertas, pasillos y elevadores tienen espacio suficiente'],
            ['loading_area', 'Existe un área segura para descarga'],
            ['maintenance_access', 'Queda espacio para servicio y mantenimiento']
        ])
    },
    {
        key: 'electrical',
        label: 'Electricidad',
        items: items([
            ['outlet_available', 'Tomacorriente disponible cerca del punto'],
            ['voltage_confirmed', 'Voltaje confirmado'],
            ['grounded_outlet', 'Conexión a tierra disponible'],
            ['circuit_capacity', 'Circuito con capacidad suficiente']
        ])
    },
    {
        key: 'water_drainage',
        label: 'Agua y drenaje',
        items: items([
            ['water_available', 'Toma de agua o espacio para botellón disponible'],
            ['water_pressure', 'Presión de agua adecuada'],
            ['drainage_available', 'Drenaje disponible cuando aplica']
        ])
    },
    {
        key: 'connectivity_security',
        label: 'Comunicación, operación y seguridad',
        items: items([
            ['cellular_signal', 'Cobertura celular adecuada'],
            ['wifi_available', 'Wi-Fi disponible cuando aplica'],
            ['equipment_security', 'Ubicación segura para el equipo'],
            ['receiving_contact', 'Persona que recibirá la instalación confirmada'],
            ['access_schedule', 'Horario y restricciones de acceso confirmados']
        ])
    }
];
